import { Project, Role, TeamMember } from '.';

export enum DirectoryType {
  BASIC_INFO_DEFAULT = 'BASIC_INFO_DEFAULT',
  PROJECT = 'PROJECT',
  TASK = 'TASK',
  PHASE = 'PHASE',
}

export enum DriverType {
  DIRECTORY = 'DIRECTORY',
  DOCUMENT = 'DOCUMENT',
}

export interface DirectoryTag {
  id: number;
  name?: string;
}

export interface Directory {
  id: number;
  directoryPath: string;
  directoryName: string;
  fullPath: string;
  directoryOwnerName: string;
  directoryOwnerEmail: string;
  directoryOwnerImage: string | null;
  directoryOwnerRoleName: Role['name'];
  directoryTags: DirectoryTag[];
  isArchived: boolean;
  directoryTypeEnum: DirectoryType;
  parentDirectory: Partial<Directory> | null;
  subDirectories: Directory[];
  project: Partial<Project>;
  documents: Document[];
  viewRoles: string;
  deleteRoles: string;
  editRoles: string;
  phaseId: number;
  createdAt: string;
  updatedAt: string;
}

export interface Document {
  id: number;
  documentExtension: string;
  documentSize: string;
  documentOriginalFileName: string;
  documentFileName: string;
  documentOwnerName: string;
  documentOwnerEmail: string;
  documentOwnerImage: string | null;
  documentOwnerRoleName: Role['name'];
  directory: number;
  directoryId: number;
  isArchived: boolean;
  downloadURL: string;
  documentTags: DirectoryTag[];
  project: Project;
  createdAt: string;
  updatedAt: string;
}

export interface TaskDocument {
  createdAt: string;
  documentExtension: string;
  documentFileName: string;
  documentOriginalFileName: string;
  documentSize: string;
  downloadURL: string;
  id: string;
  teamMemberOwner: TeamMember;
}

export interface SavedDirectory {
  id?: number;
  directoryPath?: Directory['fullPath'];
  directoryName: Directory['directoryName'];
  parentDirectory?: {
    id: Directory['id'];
  };
  project?: {
    id: Project['id'];
  };
  directoryTypeEnum?: Directory['directoryTypeEnum'];
  directoryTags?: {
    id: number;
  }[];
  viewRoles: Directory['viewRoles'];
  editRoles: Directory['editRoles'];
  deleteRoles: Directory['deleteRoles'];
}

export type DriverData =
  | {
      driverType: DriverType.DIRECTORY;
      directoryId: string;
    }
  | {
      driverType: DriverType.DOCUMENT;
      documentId: string;
    };
